<template>
  <Authenticated>
    <div class="container">
      <h1>{{ currentSite }} settings</h1>
      <section>
        <DirectSettings :site="currentSite" @update-settings="update" />
      </section>
      <!-- <h2>{{ currentSite }}</h2>
      <section class="button-container">
        <router-link :to="`/menus/${currentSite}`">Manage menu</router-link>
        <router-link v-if="currentSite != 'catering'" :to="`/operatinghours/${currentSite}`">Manage Operating hours</router-link>
        <router-link v-if="floorPlan" :to="`/floorplan/${currentSite}`">Manage floorplan</router-link>-->
      <!-- <div class="select-region">
          <h4 v-if="selectedRegion">Region: {{ selectedRegion }}</h4>
          <h4 v-else>Select a region</h4>
          <select name="region" id="region" v-model="selectedRegion" @change="setRegion()">
            <option value="" selected>Select Region</option>
            <option v-for="region in regions" :key="region" :value="region">{{ region }}</option>
          </select>
        </div> -->
      <button @click.stop.prevent="openOperatingHours = !openOperatingHours" class="action-colour">Open Operating Hours</button>
      <OperatingHours
        @closeModal="openOperatingHours = !openOperatingHours"
        :currentSite="site"
        :openModal="openOperatingHours" />
    </div>
  </Authenticated>
</template>

<script>
import { mapGetters } from "vuex";
import { OperatingHours } from "@monolith/components";
import DirectSettings from "../Settings/DirectSettings.vue";
import Authenticated from "../_layouts/Authenticated.vue";

export default {
  name: "SiteAdjust",
  components: {
    DirectSettings,
    Authenticated,
    OperatingHours,
  },
  data() {
    return {
      site: this.$route.params.site,
      openOperatingHours: false,
      currentSite: this.$route.params.site,
      floorPlan: null,
      currentYear: new Date().getFullYear(),
      lastYear: new Date().getFullYear() - 1,
    };
  },
  methods: {
    async update() {
      await this.$store.dispatch("getAllData");
      this.floorPlan = this.siteSettings[this.currentSite].floor_plan;
    },
  },
  computed: {
    ...mapGetters({
      siteSettings: "siteSettings",
      siteMap: "siteMap",
      channels: "channels",
      regions: "regions",
    }),
  },

  mounted() {
    this.floorPlan = this.siteSettings[this.currentSite].floor_plan;
  },

  watch: {},
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2rem 1rem;
  h1 {
    text-transform: capitalize;
  }
}

h2 {
  text-transform: capitalize;
  float: left;
  width: 100%;
}

.button-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin: 1rem 1rem;
  padding: 0.5rem 1rem;
  width: 95%;
  border-radius: 20px;
  background-color: var(--primary-colour);

  a {
    color: var(--text-colour);
    background-color: var(--secondary-colour);
    padding: 2rem;
    margin: 1rem;
    height: 3rem;
    border-radius: 10px;
    box-shadow: var(--box-shadow);
    text-decoration: none;
    font-size: larger;
    text-transform: capitalize;
    align-content: center;
  }

  .select-region {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 1rem;
    padding: 2rem;
    height: 3rem;
    border-radius: 10px;
    background-color: var(--secondary-colour);
    box-shadow: var(--box-shadow);
    h4 {
      margin: 0.5rem;
    }
    select {
      padding: 0.5rem;
      margin: 0.5rem;
      border-radius: 10px;
      box-shadow: var(--box-shadow);
    }
  }
}

@media only screen and (orientation: portrait) {
  .container {
    margin: 0 auto;
    .button-container {
      flex-direction: column;
      margin: auto;
      padding: 1rem;
      width: 80%;
      a,
      .select-region {
        width: 75%;
      }
    }
  }
}
</style>
